<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>New Make</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" small text to="/makes">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <!-- editor -->
        <editor :docCreate="docCreate" :initial="dataItem" @data="save"></editor>
        <!-- end -->
      </v-card-text>
    </v-card>

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import Editor from "../_components/editor.vue";
export default {
  components: {
    Editor,
  },
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  data: () => ({
    dataItem: {},
    docCreate: true,
    storeSpecific: ""
  }),
  methods: {
    save(data) {
      if(this.storeSpecific == 'Y') {
        data.store_id = this.activeStore;
      }
      const url = "/product-makes";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.$router.push("/makes");
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData) {
              self.storeSpecific = res.ResponseData.storeSpecific;
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getGenSettings();
  }
};
</script>